/** @flow */
const isFunction = (arg: any): boolean %checks => typeof arg === 'function';

export default isFunction;
